import type { Directive } from 'vue'

export const vMpNoTrack: Directive = {
  mounted(el: HTMLElement) {
    el.setAttribute('data-mp-no-track', '')
  },
  updated(el: HTMLElement) {
    if (!el.hasAttribute('data-mp-no-track')) {
      el.setAttribute('data-mp-no-track', '')
    }
  },
}
